















































// Importing components
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {getAddresses} from '@/ts/profile/addresses/get-addresses';
import {deleteAddress} from '@/ts/profile/addresses/delete-address';
import {modalConfirm} from '@/ts/other/additional';
// Importing variables
import {Success, SuccessfulAction} from '@/ts/variables';

export default {
    name: 'TheTableAddresses',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        fireModal(id, index) {
            modalConfirm().then(() => {
                deleteAddress(id).then(() => {
                    this.$swal.fire(Success, SuccessfulAction, 'success');
                    this.$store.dispatch('removeResponseItem', index);
                });
            });
        },
        sort() {
            this.$store.dispatch('setLoadingOn');
            getAddresses().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
};
